/**
 * @author xzc
 * 功能：销售目录
 */

import { Service } from '@/tools'

export class CatalogService<T extends TSettle.Catalog> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.Catalog}`, data?: any, toast?: string) {
    return this.post(url, data, toast)
  }

  // 结算目录分页列表
  // /api/settle/catalog/v1/getCatalogPageList
  getCatalogPageList = <K extends T['ApiGetCatalogPageList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetCatalogPageList', data)

  // 结算目录确认
  // /api/settle/catalog/v1/catalogConfirm
  catalogConfirm = <K extends T['ApiCatalogConfirm']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCatalogConfirm', data)

  // 结算目录提交-保存
  // /api/settle/catalog/v1/updateCatalog
  updateCatalog = <K extends T['ApiUpdateCatalog']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateCatalog', data)

  // 结算目录删除
  // /api/settle/catalog/v1/deleteCatalog
  deleteCatalog = <K extends T['ApiDeleteCatalog']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteCatalog', data)

  //结算目录详情
  // /api/settle/catalog/v1/getCatalogDetail
  getCatalogDetail = <K extends T['ApiGetCatalogDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetCatalogDetail', data)
}
